// import React, { useEffect, useRef, useState } from "react";
// import { subYears } from "date-fns/subYears";
// import { API_ENDPOINTS, TERMS } from "../../constant/_constant";
// import usePostRequest from "../../hooks/usePostRequest";
// import * as XLSX from "xlsx";
// import {
//   Form,
//   Card,
//   Row,
//   Col,
//   Button,
//   Dropdown,
//   InputGroup,
//   ProgressBar,
//   Accordion,
// } from "react-bootstrap";
// import { pdf } from "@react-pdf/renderer";
// import {
//   IconPaperclip,
//   IconDotsVertical,
//   IconPencil,
//   IconEye,
//   IconHistoryToggle,
//   IconFileTypePdf,
//   IconMailSpark,
//   IconBox,
//   IconMessageCircle,
//   IconChevronRight,
//   IconCalendarWeek,
//   IconFileTypeXls,
//   IconFileSearch,
//   IconSortAscending,
//   IconLayoutGridFilled,
//   IconLayoutListFilled,
// } from "@tabler/icons-react";
// import moment from "moment";
// import { toast } from "react-toastify";
// import { MultiSelect } from "primereact/multiselect";
// import { useSelector } from "react-redux";
// import { useNavigate } from "react-router-dom";
// import PdfDocument from "./PDF/main";
// import SuccsessMsgModal from "../../components/SuccessMsgModal";
// import GetOrderHistoryDialog from "./GetOrderHistoryDialog";
// import Product_Revistion_order from "./Product_Revistion_order";
// import EmailQuoteDialogOrder from "./Email/EmailQuoteDialogOrder";
// import EmailHistoryOrder from "./Email/EmailHistoryOrder";
// import OrderKOorCustomerEmailDialog from "./Email/OrderKOorCustomerEmailDialog";
// import ExcelDialogOrder from "./ExcelDialogOrder";
// import DatePicker from "react-datepicker";
// import View_DetailsLifecycle from "./ViewDetail/View_DetailsLifecycle";
// import LifeCycleListing from "./LifeCycleListing";

// const STATUS_COLORS = {
//   DRAFT: "#8A97AB",
//   PENDING: "#F59F00",
//   "IN PROGRESS": "#066FD1",
//   REACHED_WAREHOUSE: "#305edf",
//   SHIPPED: "#AE3EC9",
//   DELIVERED: "#42ad9f",
//   PAID_CLOSED: "#06a159",
//   LOST_CANCELLED: "#D63939",
// };

// const ORDER_TYPE_MAP = {
//   DS: "Dropship",
//   CRK: "Consolidate / Repack / Kit",
//   M: "Manufacturing",
//   KIT: "Kit",
// };

// const badgeStyle = (color) => ({
//   backgroundColor: color,
//   color: "#fff",
//   borderRadius: "10px",
//   padding: "2px 12px",
//   fontSize: "14px",
//   display: "inline-block",
// });

// const statusOptions = [
//   { label: "Payment Pending", value: "DRAFT" },
//   { label: "Pending", value: "PENDING" },
//   { label: "In Progress", value: "IN PROGRESS" },
//   { label: "At Warehouse", value: "REACHED_WAREHOUSE" },
//   { label: "Shipped", value: "SHIPPED" },
//   { label: "Delivered", value: "DELIVERED" },
//   { label: "Paid & Closed", value: "PAID_CLOSED" },
// ];

// const sortOptionsMap = {
//   recently_updated: {
//     sort_by: "updated_at",
//     sort_order: "desc",
//     label: "Recently Updated",
//   },
//   created_date_closest: {
//     sort_by: "published_date",
//     sort_order: "desc",
//     label: "Created date closest to now",
//   },
//   created_date_farthest: {
//     sort_by: "published_date",
//     sort_order: "asc",
//     label: "Created date farthest from now",
//   },
//   due_date_closest: {
//     sort_by: "estimated_date",
//     sort_order: "desc",
//     label: "Due date closest to now",
//   },
//   due_date_farthest: {
//     sort_by: "estimated_date",
//     sort_order: "asc",
//     label: "Due date farthest from now",
//   },
// };

// const TableListing = ({viewType}) => {
//   const todayDate = new Date();
//   const oneYearAgo = subYears(todayDate, 1);

//   const [ordersData, setOrdersData] = useState({}); // response.data keyed by status
//   const [activeTabs, setActiveTabs] = useState({}); // { [statusKey]: stageValue }
//   const [stagePages, setStagePages] = useState({}); // { [`${statusKey}|${stageValue}`]: page }
//   const [loadingStage, setLoadingStage] = useState(null);

//   const [limit] = useState(10);
//   const [orderSku, setOrderSku] = useState("");
//   const [startDate, setStartDate] = useState(oneYearAgo);
//   const [endDate, setEndDate] = useState(todayDate);
//   const [selectedStatus, setSelectedStatus] = useState([]);
//   const [highlightedOrders, setHighlightedOrders] = useState([]);
//   const [sortOption, setSortOption] = useState("recently_updated");
//   const [search, setSearch] = useState("");
//   const [salesHeadFilter, setSalesHeadFilter] = useState("");
//   const [contractFilter, setContractFilter] = useState("");
//   const [openDropdown, setOpenDropdown] = useState(null);
//   const [isListView, setIsListView] = useState(true);

//   const [isSuccsessModalOpen, setIsSuccsessModalOpen] = useState({
//     show: false,
//     message: "",
//     btntext: "Close",
//     title: "Success",
//   });
//   const [isModalOpen, setIsModalOpen] = useState({ show: false });
//   const [isHistoryOpen, setIsHistoryOpen] = useState({ show: false });
//   const [isExcelOpen, setIsExcelOpen] = useState({ show: false });
//   const [isEmaillOpen, setIsEmaillOpen] = useState({
//     title: "",
//     show: false,
//     row: "",
//     skuData: "",
//     defaultSubject: "",
//     Quote_No: "",
//     ORDERID: "",
//     toEmail: "",
//     toName: "",
//   });
//   const [isEmailQuoteOpen, setIsEmailQuoteOpen] = useState({
//     show: false,
//     Quote_No: "",
//     order_id: "",
//   });
//   const [isEmailHistoryOpen, setIsEmailHistoryOpen] = useState({
//     show: false,
//     order_id: "",
//   });
//   const [isViewOpen, setIsViewOpen] = useState({
//     show: false,
//     order: [],
//     isStatusUpdate: false,
//   });

//   const user = useSelector((state) => state.auth.user);
//   const navigate = useNavigate();
//   const searchInputRef = useRef();
//   const tableWrapperRefs = useRef({});

//   const { isLoading, postData: fetchOrders } = usePostRequest(
//     API_ENDPOINTS.ORDER_LIST_NEW
//   );
//   const { data: contractData, postData: fetchContract } = usePostRequest(
//     API_ENDPOINTS.GET_CONTRACT
//   );
//   const { data: SalesHead, postData: fetchRfq } = usePostRequest(
//     API_ENDPOINTS.GET_RFQ_USERS
//   );

//   const buildPayload = (extra = {}) => ({
//     page: 1,
//     limit,
//     created_date_from: startDate
//       ? moment(startDate).format("YYYY-MM-DD")
//       : undefined,
//     created_date_to: endDate ? moment(endDate).format("YYYY-MM-DD") : undefined,
//     sales_lead_email: salesHeadFilter || undefined,
//     search: search?.length > 0 ? search : undefined,
//     contract_type_id: contractFilter?.length > 0 ? contractFilter : undefined,
//     status: selectedStatus.length > 0 ? selectedStatus : undefined,
//     sort_by: sortOptionsMap[sortOption].sort_by,
//     sort_order: sortOptionsMap[sortOption].sort_order,
//     ...extra,
//     department:viewType || "finance"
//   });

//   const loadOrders = () => {
//     fetchOrders(buildPayload(), (response) => {
//       const data = response?.data || {};
//       setOrdersData(data);
//       // default active tab = first stage of each status
//       const tabs = {};
//       const pages = {};
//       Object.entries(data).forEach(([statusKey, statusObj]) => {
//         const first = statusObj?.stage?.[0];
//         if (first) {
//           tabs[statusKey] = first.value;
//           statusObj.stage.forEach((st) => {
//             pages[`${statusKey}|${st.value}`] = 1;
//           });
//         }
//       });
//       setActiveTabs(tabs);
//       setStagePages(pages);
//     });
//   };

//   useEffect(() => {
//     fetchRfq({ module_type: "ORDER" });
//     fetchContract();
//     loadOrders();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, []);

//   const handleSearch = () => {
//     const searchValue = searchInputRef.current?.value?.trim();
//     if ((startDate && !endDate) || (!startDate && endDate)) {
//       toast.warning("Please select both the dates.");
//       return;
//     }
//     setSearch(searchValue ?? "");
//     loadOrders();
//   };

//   const handleClearFilter = () => {
//     setSalesHeadFilter("");
//     setContractFilter("");
//     setSelectedStatus([]);
//     setSearch("");
//     setStartDate(oneYearAgo);
//     setEndDate(todayDate);
//     setSortOption("recently_updated");
//     fetchOrders(
//       {
//         page: 1,
//         limit,
//         created_date_from: moment(oneYearAgo).format("YYYY-MM-DD"),
//         created_date_to: moment(todayDate).format("YYYY-MM-DD"),
//         sort_by: sortOptionsMap.recently_updated.sort_by,
//         sort_order: sortOptionsMap.recently_updated.sort_order,
//       },
//       (response) => {
//         const data = response?.data || {};
//         setOrdersData(data);
//         const tabs = {};
//         const pages = {};
//         Object.entries(data).forEach(([statusKey, statusObj]) => {
//           const first = statusObj?.stage?.[0];
//           if (first) {
//             tabs[statusKey] = first.value;
//             statusObj.stage.forEach((st) => {
//               pages[`${statusKey}|${st.value}`] = 1;
//             });
//           }
//         });
//         setActiveTabs(tabs);
//         setStagePages(pages);
//       }
//     );
//   };

//   const handleSortChange = (sortKey) => {
//     setSortOption(sortKey);
//     fetchOrders(buildPayload({ ...sortOptionsMap[sortKey] }), (response) => {
//       setOrdersData(response?.data || {});
//     });
//   };

//   const handleLoadMore = (statusKey, stage) => {
//     const key = `${statusKey}|${stage.value}`;
//     const nextPage = (stagePages[key] || 1) + 1;
//     setLoadingStage(key);
//     fetchOrders(
//       buildPayload({
//         page: nextPage,
//         status: statusKey,
//         sub_status: stage.col_name === "sub_status" ? stage.value : undefined,
//       }),
//       (response) => {
//         const incoming =
//           response?.data?.[statusKey]?.stage?.find(
//             (s) => s.value === stage.value
//           )?.data || [];
//         setOrdersData((prev) => {
//           const copy = { ...prev };
//           const statusObj = { ...copy[statusKey] };
//           statusObj.stage = statusObj.stage.map((s) => {
//             if (s.value !== stage.value) return s;
//             const combined = [...s.data, ...incoming];
//             const unique = Array.from(
//               new Map(combined.map((i) => [i.invoice_no, i])).values()
//             );
//             return { ...s, data: unique };
//           });
//           copy[statusKey] = statusObj;
//           return copy;
//         });
//         setStagePages((prev) => ({ ...prev, [key]: nextPage }));
//         setLoadingStage(null);
//       },
//       () => setLoadingStage(null)
//     );
//   };

//   // ---------- helpers ----------
//   const getProgressPercentage = (cardData) => {
//     if (!Array.isArray(cardData) || cardData.length === 0) return 0;
//     const active = cardData.filter((i) => !i.is_deleted);
//     if (active.length === 0) return 0;
//     return Math.round(
//       (active.filter((i) => i.check_status).length / active.length) * 100
//     );
//   };

//   const getOverdueClass = (dateString) => {
//     if (!dateString) return "";
//     const estimatedDate = new Date(dateString);
//     const today = new Date();
//     estimatedDate.setHours(0, 0, 0, 0);
//     today.setHours(0, 0, 0, 0);
//     const daysOverdue = Math.floor(
//       (today - estimatedDate) / (1000 * 60 * 60 * 24)
//     );
//     if (daysOverdue >= 21) return "bg-forred";
//     if (daysOverdue >= 10) return "bg-fororange";
//     if (daysOverdue >= 2) return "bg-overdate";
//     return "";
//   };

//   const triggerCardHighlight = (orderId) => {
//     setHighlightedOrders((prev) => [...prev, orderId]);
//     setTimeout(() => {
//       setHighlightedOrders((prev) => prev.filter((id) => id !== orderId));
//     }, 3000);
//   };

//   const toggleDropdown = (id, wrapperKey) => {
//     const isOpening = openDropdown !== id;
//     setOpenDropdown(isOpening ? id : null);
//     Object.entries(tableWrapperRefs.current).forEach(([key, el]) => {
//       if (!el) return;
//       el.style.overflow = key === wrapperKey && isOpening ? "visible" : "auto";
//     });
//   };

//   const handleDropdownAction = (wrapperKey, action) => {
//     setOpenDropdown(null);
//     if (tableWrapperRefs.current[wrapperKey]) {
//       tableWrapperRefs.current[wrapperKey].style.overflow = "auto";
//     }
//     action();
//   };

//   const handleViewClick = (row) => {
//     setIsViewOpen({ show: true, order: row, isStatusUpdate: false });
//     const newUrl = `${window.location.pathname}?${row.order_id}`;
//     window.history.pushState(null, "", newUrl);
//   };

//   const handleHistoryOpen = (e, order) => {
//     e?.preventDefault();
//     setOrderSku(order);
//     setIsHistoryOpen({ show: true });
//   };

//   const handleORDERRVERSION_OPEN = (e, order) => {
//     setOrderSku(order);
//     setIsModalOpen({ show: true });
//   };

//   const PD = new Date();
//   const today = new Intl.DateTimeFormat("en-US", {
//     dateStyle: "medium",
//   }).format(PD);

//   const HandlePDFClick = async (row) => {
//     const OP_arr = String(`order`)
//       .split(".")
//       .map((s) => s.charAt(0).toUpperCase() + s.slice(1));
//     const updatedInvoiceData = {
//       invoice_num: String(row.order_id),
//       Contract_Vehicle: row.ContractType?.name,
//       KO_name: row.orderKo?.name,
//       KO_email: row.orderKo?.email,
//       KO_phone: row.orderKo?.phone,
//       KO_address: row.orderKo?.address,
//       Print_Date: String(today),
//       trans_date: String(row.updated_at).split("T")[0],
//       estimated_date: row.estimated_date,
//       Address:
//         "ASPETTO INC, 150 Riverside pkwy. Suite 203. Fredericksburg, VA 22406 USA",
//       items: row.OrderProductSales,
//       Tax: row.tax,
//       Shipping_Cost: row.shipping_cost,
//       Total_Cost: row.total_cost_after_margin,
//       Other_Cost: row.other_cost_json,
//       BillTo_Phone: row.orderBilling?.phone,
//       BillTo_Name: row.orderBilling?.name,
//       BillTo_Address: row.orderBilling?.address,
//       BillTo_Email: row.orderBilling?.email,
//       Shipping_Details: {
//         Organization_Name: row?.organization_name,
//         KO_name: row.orderKo?.name,
//         Sales_Head_Info: {
//           Name: row.sales_lead_name,
//           Email: row.sales_lead_email,
//           Phone: row.sales_lead_phone,
//         },
//         Customer_Name: row.orderShipping?.name,
//         Customer_Email: row.orderShipping?.email,
//         Customer_Phone: row.orderShipping?.phone,
//         Customer_Address: row.orderShipping?.address,
//         Shipping_Method: row.shipping_method,
//         Shipping_Method_Detail: row.shipping_method_detail,
//         Shipping_Terms: row.shipping_term,
//         Estimated_Delivery: row.estimated_delivery,
//         Payment_Terms: row.payment_term,
//         Payment_Terms_Details: row.payment_term_detail,
//       },
//     };
//     setTimeout(async () => {
//       const pdfBlob = await pdf(
//         <PdfDocument invoicedata={updatedInvoiceData} />
//       ).toBlob();
//       const url = URL.createObjectURL(pdfBlob);
//       const a = document.createElement("a");
//       a.href = url;
//       a.download = `${OP_arr.join(" ")} ${String(row.invoice_no).split(".")[0]}.pdf`;
//       document.body.appendChild(a);
//       a.click();
//       document.body.removeChild(a);
//       URL.revokeObjectURL(url);
//     }, 0);
//   };

//   // ---------- excel ----------
//   const getAllRows = () =>
//     Object.values(ordersData).flatMap((s) =>
//       (s?.stage || []).flatMap((st) => st.data || [])
//     );

//   const handleGenerateExcel = (selectedFields) => {
//     try {
//       const excelData = getAllRows();
//       if (!excelData.length) throw new Error("No data available to export");
//       if (!selectedFields?.length)
//         throw new Error("No fields selected for export");

//       const formattedData = excelData.map((row) => {
//         const filteredRow = {};
//         selectedFields.forEach((field) => {
//           switch (field) {
//             case "Order Type":
//               filteredRow[field] = row?.order_type || "";
//               break;
//             case "Order ID":
//               filteredRow[field] = row.order_id || "";
//               break;
//             case "Contract Vehicle":
//               filteredRow[field] = row.ContractType?.name || "";
//               break;
//             case "KO name":
//               filteredRow[field] = row.orderKo?.name || "";
//               break;
//             case "KO email":
//               filteredRow[field] = row.orderKo?.email || "";
//               break;
//             case "KO phone":
//               filteredRow[field] = row.orderKo?.phone || "";
//               break;
//             case "KO address":
//               filteredRow[field] = row.orderKo?.address || "";
//               break;
//             case "Date Created":
//             case "Created Date":
//               filteredRow[field] = row.published_date
//                 ? moment(row.published_date).format("MM/DD/YYYY")
//                 : "";
//               break;
//             case "Estimated Date Fulfilled":
//               filteredRow[field] = row.estimated_date
//                 ? moment(row.estimated_date).format("MM/DD/YYYY")
//                 : "";
//               break;
//             case "Actual Date Fulfilled":
//               filteredRow[field] = row.actual_date
//                 ? moment(row.actual_date).format("MM/DD/YYYY")
//                 : "";
//               break;
//             case "Order Description":
//               filteredRow[field] = row.brief;
//               break;
//             case "Organization Name":
//               filteredRow[field] = row.organization_name;
//               break;
//             case "Customer Name":
//               filteredRow[field] = row.orderShipping?.name;
//               break;
//             case "Customer Email":
//               filteredRow[field] = row.orderShipping?.email;
//               break;
//             case "Customer Phone":
//               filteredRow[field] = row.orderShipping?.phone;
//               break;
//             case "Customer Address":
//               filteredRow[field] = row.orderShipping?.address;
//               break;
//             case "Shipping Method":
//               filteredRow[field] = row.shipping_method;
//               break;
//             case "Sales Head Name":
//               filteredRow[field] = row.sales_lead_name;
//               break;
//             case "Sales Head Email":
//               filteredRow[field] = row.sales_lead_email;
//               break;
//             case "Sales Head Ph":
//               filteredRow[field] = row.sales_lead_phone;
//               break;
//             case "Shipping Terms":
//               filteredRow[field] = row.shipping_term || "";
//               break;
//             case "Estimated Delivery":
//               filteredRow[field] = row.estimated_delivery;
//               break;
//             case "Payment Terms": {
//               const term = TERMS.Term.find((t) => t.Id === row.payment_term);
//               if (term) filteredRow[field] = term.Name;
//               break;
//             }
//             case "Other Cost":
//             case "Custom Field": {
//               if (row.other_cost_json) {
//                 try {
//                   const otherCosts = Array.isArray(row.other_cost_json)
//                     ? row.other_cost_json
//                     : JSON.parse(row.other_cost_json);
//                   otherCosts.forEach((cost, idx) => {
//                     if (cost.Name)
//                       filteredRow[`Other Cost Name${idx + 1}`] = cost.Name;
//                     if (cost.Amount)
//                       filteredRow[`Other Cost ${idx + 1}($)`] = cost.Amount;
//                   });
//                 } catch (e) {
//                   console.error("Error parsing other_cost_json:", e);
//                 }
//               }
//               break;
//             }
//             case "Shipping Cost($)":
//               filteredRow[field] = row.shipping_cost;
//               break;
//             case "Tax($)":
//               filteredRow[field] = row.tax;
//               break;
//             case "Total Cost Before Margin($)":
//               filteredRow[field] = row.total_cost_before_margin;
//               break;
//             case "Total Cost After Margin($)":
//               filteredRow[field] = row.total_cost_after_margin;
//               break;
//             case "Last Updated Date":
//               filteredRow[field] = row.updated_at
//                 ? moment(row.updated_at).format("MM/DD/YYYY")
//                 : "";
//               break;
//             case "Status":
//               filteredRow[field] = row.status;
//               break;
//             default:
//               filteredRow[field] = "";
//           }
//         });
//         return filteredRow;
//       });

//       const wb = XLSX.utils.book_new();
//       const ws = XLSX.utils.json_to_sheet(formattedData);
//       XLSX.utils.book_append_sheet(wb, ws, "ASPETTO SALES");
//       XLSX.writeFile(
//         wb,
//         "ASPETTO SALES-" + String(new Date()).split("T")[0] + ".xlsx"
//       );
//     } catch (error) {
//       toast.error(error.message);
//     }
//   };

//   // ---------- row dropdown ----------
//   const renderActionDropdown = (row, rowId, wrapperKey) => (
//     <td style={{ position: "relative" }}>
//       <button
//         onClick={() => toggleDropdown(rowId, wrapperKey)}
//         style={{ background: "transparent", border: "none", cursor: "pointer" }}
//       >
//         <IconDotsVertical size={20} />
//       </button>
//       {openDropdown === rowId && (
//         <ul className="order-dropdown-menu p-0">
//           <li
//             className="dropdown-item"
//             onClick={() =>
//               handleDropdownAction(wrapperKey, () =>
//                 navigate(`/edit-order/${row?.order_id}`)
//               )
//             }
//           >
//             <span>
//               {canRequestOrderChange(row?.status) ? <IconEye stroke={1} /> : <IconPencil stroke={1} />}{" "}{canRequestOrderChange(row?.status) ? "Change Request" : "Edit Order"}
//             </span>
//             <IconChevronRight stroke={1} />
//           </li>
//           <li
//             className="dropdown-item border-top"
//             onClick={() =>
//               handleDropdownAction(wrapperKey, () => handleViewClick(row))
//             }
//           >
//             <span>
//               <IconEye stroke={1} /> View Order
//             </span>
//             <IconChevronRight stroke={1} />
//           </li>
//           <li
//             className="dropdown-item border-top"
//             onClick={() =>
//               handleDropdownAction(wrapperKey, () =>
//                 handleORDERRVERSION_OPEN(null, row.order_id)
//               )
//             }
//           >
//             <span>
//               <IconHistoryToggle stroke={1} /> Changes
//             </span>
//             <IconChevronRight stroke={1} />
//           </li>
//           <li
//             className="dropdown-item border-top"
//             onClick={() =>
//               handleDropdownAction(wrapperKey, () => HandlePDFClick(row))
//             }
//           >
//             <span>
//               <IconFileTypePdf stroke={1} /> PDF
//             </span>
//             <IconChevronRight stroke={1} />
//           </li>
//           <li
//             className="dropdown-item border-top"
//             onClick={() =>
//               handleDropdownAction(wrapperKey, () =>
//                 setIsEmailHistoryOpen({ show: true, order_id: row.order_id })
//               )
//             }
//           >
//             <span>
//               <IconMailSpark stroke={1} /> Email
//             </span>
//             <IconChevronRight stroke={1} />
//           </li>
//           <li className="border-top">
//             <div className="rfq_lis_short justify-content-center p-2">
//               <span>
//                 <IconBox stroke={1} /> {row.product_count}
//               </span>
//               <span>
//                 <IconPaperclip stroke={1} /> {row.attachment_count}
//               </span>
//               <span>
//                 <IconMessageCircle stroke={1} /> {row.notes_count}
//               </span>
//             </div>
//           </li>
//         </ul>
//       )}
//     </td>
//   );

//   const renderStageTable = (statusKey, stage) => {
//     const wrapperKey = `${statusKey}|${stage.value}`;
//     const rows = stage?.data || [];
//     const stageKey = `${statusKey}|${stage.value}`;
//     const hasMore = rows.length < (stage?.total || 0);
//     return (
//       <div
//         className="table-responsive mail_wrapper border-0 p-0"
//         ref={(el) => (tableWrapperRefs.current[wrapperKey] = el)}
//         style={{ overflowX: "auto" }}
//       >
//         <table className="table">
//           <thead>
//             <tr>
//               <th>Order ID</th>
//               <th>Sales Lead</th>
//               <th>Contract Vehicle</th>
//               <th>Created Date</th>
//               <th>Due Date</th>
//               <th>Type</th>
//               <th>Total Cost</th>
//               <th>Up Next</th>
//               <th>Action</th>
//             </tr>
//           </thead>
//           <tbody>
//             {rows.length > 0 ? (
//               rows.map((row, index) => {
//                 const overdueClass = getOverdueClass(row?.estimated_date);
//                 const progress = getProgressPercentage(
//                   row?.OrderChainOfCustodies
//                 );
//                 const rowId = `${wrapperKey}-${row.order_id}-${index}`;
//                 return (
//                   <tr
//                     key={row.invoice_no || index}
//                     className={`align-middle ${overdueClass} ${
//                       highlightedOrders.includes(row.order_id)
//                         ? "highlight-pending"
//                         : ""
//                     }`}
//                   >
//                     <td>{row.order_id}</td>
//                     <td>{row?.sales_lead_name || "N/A"}</td>
//                     <td>{row?.ContractType?.name || "N/A"}</td>
//                     <td>{moment(row?.published_date).format("MM/DD/YYYY")}</td>
//                     <td>{moment(row?.estimated_date).format("MM/DD/YYYY")}</td>
//                     <td>
//                       {ORDER_TYPE_MAP[row?.order_type] ||
//                         row?.order_type ||
//                         "N/A"}
//                     </td>
//                     <td className="text-primary">
//                       ${row?.total_cost_after_margin}
//                     </td>
//                     <td>
//                       <div>
//                         <div className="d-flex gap-1">
//                           <p className="mb-1 text-dark">
//                             {row?.coc_next_step || "No steps available"}
//                           </p>
//                         </div>
//                         <ProgressBar
//                           variant="warning"
//                           now={progress}
//                           style={{ height: "6px", width: "100%" }}
//                         />
//                       </div>
//                     </td>
//                     {renderActionDropdown(row, rowId, wrapperKey)}
//                   </tr>
//                 );
//               })
//             ) : (
//               <tr>
//                 <td colSpan="9" className="text-center border-0">
//                   No data found.
//                 </td>
//               </tr>
//             )}
//           </tbody>
//         </table>
//         {hasMore && rows.length >= limit && (
//           <div className="text-center mt-3">
//             <Button
//               variant="outline-primary"
//               onClick={() => handleLoadMore(statusKey, stage)}
//               disabled={loadingStage === stageKey}
//             >
//               {loadingStage === stageKey ? "Loading..." : "Load More"}
//             </Button>
//           </div>
//         )}
//       </div>
//     );
//   };

//   return (
//     <>
//       {isHistoryOpen.show && (
//         <GetOrderHistoryDialog
//           orderSku={orderSku}
//           show={isHistoryOpen.show}
//           setShow={setIsHistoryOpen}
//         />
//       )}
//       {isModalOpen.show && (
//         <Product_Revistion_order
//           orderSku={orderSku}
//           show={isModalOpen.show}
//           setShow={setIsModalOpen}
//         />
//       )}
//       {isEmailQuoteOpen.show && (
//         <EmailQuoteDialogOrder
//           username={user.username}
//           show={isEmailQuoteOpen.show}
//           order_id={isEmailQuoteOpen.order_id}
//           setShow={setIsEmailQuoteOpen}
//           setIsSuccsessModalOpen={setIsSuccsessModalOpen}
//         />
//       )}
//       {isEmailHistoryOpen.show && (
//         <EmailHistoryOrder
//           username={user.username}
//           show={isEmailHistoryOpen.show}
//           order_id={isEmailHistoryOpen.order_id}
//           setShow={setIsEmailHistoryOpen}
//           setIsSuccsessModalOpen={setIsSuccsessModalOpen}
//         />
//       )}
//       {isViewOpen.show && (
//         <View_DetailsLifecycle
//           show={isViewOpen.show}
//           setShow={setIsViewOpen}
//           order={isViewOpen.order}
//           isStatusUpdate={isViewOpen.isStatusUpdate}
//           onStatusUpdate={() => {
//             setIsViewOpen((prev) => ({ ...prev, isStatusUpdate: true }));
//             loadOrders();
//           }}
//           triggerCardHighlight={triggerCardHighlight}
//         />
//       )}
//       {isEmaillOpen.show && (
//         <OrderKOorCustomerEmailDialog
//           pagetitle={isEmaillOpen.title}
//           toEmail={isEmaillOpen.toEmail}
//           toName={isEmaillOpen.toName}
//           ORDERID={isEmaillOpen.ORDERID}
//           show={isEmaillOpen.show}
//           skuData={isEmaillOpen.skuData}
//           row={isEmaillOpen.row}
//           defaultSubject={isEmaillOpen.defaultSubject}
//           Quote_No={isEmaillOpen.Quote_No}
//           setShow={setIsEmaillOpen}
//           setIsSuccsessModalOpen={setIsSuccsessModalOpen}
//         />
//       )}
//       {isExcelOpen.show && (
//         <ExcelDialogOrder
//           show={isExcelOpen.show}
//           setShow={setIsExcelOpen}
//           onDownload={(fields) => {
//             handleGenerateExcel(fields);
//             setIsExcelOpen({ show: false });
//           }}
//         />
//       )}
//       <SuccsessMsgModal
//         show={isSuccsessModalOpen.show}
//         onHide={() =>
//           setIsSuccsessModalOpen({ ...isSuccsessModalOpen, show: false })
//         }
//         title={isSuccsessModalOpen?.title}
//         btntext={isSuccsessModalOpen?.btntext}
//         message={isSuccsessModalOpen?.message}
//       />

//       {isListView && (
//         <>
//           <div className="order_list_view">
//             {isLoading && Object.keys(ordersData).length === 0 ? (
//               <div className="text-center p-4">Loading...</div>
//             ) : (
//               <Accordion defaultActiveKey="0">
//                 {Object.entries(ordersData).map(
//                   ([statusKey, statusObj], idx) => {
//                     const stages = statusObj?.stage || [];
//                     const activeStageValue =
//                       activeTabs[statusKey] ?? stages[0]?.value;
//                     const activeStage =
//                       stages.find((s) => s.value === activeStageValue) ||
//                       stages[0];
//                     const totalCount = stages.reduce(
//                       (sum, s) => sum + (s.total || 0),
//                       0
//                     );
//                     const color = STATUS_COLORS[statusKey] || "#8A97AB";
//                     return (
//                       <Accordion.Item
//                         eventKey={String(idx)}
//                         key={statusKey}
//                         className="border-0"
//                       >
//                         <Accordion.Header>
//                           <div className="d-flex justify-content-between align-items-center w-100">
//                             <span className="order_status_box">
//                               {statusObj.display_name}{" "}
//                               <b style={badgeStyle(color)}>{totalCount}</b>
//                             </span>
//                             {stages.length > 1 && (
//                               <div
//                                 className="table_tabs_group d-flex gap-2"
//                                 onClick={(e) => e.stopPropagation()}
//                               >
//                                 {stages.map((s) => (
//                                   <button
//                                     key={s.value}
//                                     type="button"
//                                     className={`btn btn-sm ${
//                                       activeStageValue === s.value
//                                         ? "btn-warning text-white"
//                                         : "btn-outline-secondary"
//                                     }`}
//                                     onClick={(e) => {
//                                       e.stopPropagation();
//                                       setActiveTabs((prev) => ({
//                                         ...prev,
//                                         [statusKey]: s.value,
//                                       }));
//                                     }}
//                                   >
//                                     {s.display_name} ({s.total || 0})
//                                   </button>
//                                 ))}
//                               </div>
//                             )}
//                           </div>
//                         </Accordion.Header>
//                         <Accordion.Body>
//                           {activeStage &&
//                             renderStageTable(statusKey, activeStage)}
//                         </Accordion.Body>
//                       </Accordion.Item>
//                     );
//                   }
//                 )}
//               </Accordion>
//             )}
//           </div>
//         </>
//       )}
//       {/* {!isListView && <LifeCycleListing />} */}
//     </>
//   );
// };

// export default TableListing;


// import React, { useEffect, useRef, useState } from "react";
// import { TERMS } from "../../constant/_constant";
// import * as XLSX from "xlsx";
// import { Button, ProgressBar, Accordion } from "react-bootstrap";
// import { pdf } from "@react-pdf/renderer";
// import {
//   IconPaperclip,
//   IconDotsVertical,
//   IconPencil,
//   IconEye,
//   IconHistoryToggle,
//   IconFileTypePdf,
//   IconMailSpark,
//   IconBox,
//   IconMessageCircle,
//   IconChevronRight,
// } from "@tabler/icons-react";
// import moment from "moment";
// import { toast } from "react-toastify";
// import { useSelector } from "react-redux";
// import { useNavigate } from "react-router-dom";
// import PdfDocument from "./PDF/main";
// import SuccsessMsgModal from "../../components/SuccessMsgModal";
// import GetOrderHistoryDialog from "./GetOrderHistoryDialog";
// import Product_Revistion_order from "./Product_Revistion_order";
// import EmailQuoteDialogOrder from "./Email/EmailQuoteDialogOrder";
// import EmailHistoryOrder from "./Email/EmailHistoryOrder";
// import OrderKOorCustomerEmailDialog from "./Email/OrderKOorCustomerEmailDialog";
// import ExcelDialogOrder from "./ExcelDialogOrder";
// import View_DetailsLifecycle from "./ViewDetail/View_DetailsLifecycle";

// const STATUS_COLORS = {
//   DRAFT: "#8A97AB",
//   PENDING: "#F59F00",
//   "IN PROGRESS": "#066FD1",
//   REACHED_WAREHOUSE: "#305edf",
//   SHIPPED: "#AE3EC9",
//   DELIVERED: "#42ad9f",
//   PAID_CLOSED: "#06a159",
//   LOST_CANCELLED: "#D63939",
// };

// const ORDER_TYPE_MAP = {
//   DS: "Dropship",
//   CRK: "Consolidate / Repack / Kit",
//   M: "Manufacturing",
//   KIT: "Kit",
// };

// const badgeStyle = (color) => ({
//   backgroundColor: color,
//   color: "#fff",
//   borderRadius: "10px",
//   padding: "2px 12px",
//   fontSize: "14px",
//   display: "inline-block",
// });

// const TableListingNew = ({
//   data = {},
//   limit = 10,
//   loadingStates = {},
//   hasMoreData = {},
//   onLoadMore,
//   onRefresh,
// }) => {
//   const [activeTabs, setActiveTabs] = useState({});
//   const [highlightedOrders, setHighlightedOrders] = useState([]);
//   const [openDropdown, setOpenDropdown] = useState(null);
//   const [orderSku, setOrderSku] = useState("");

//   const [isSuccsessModalOpen, setIsSuccsessModalOpen] = useState({
//     show: false,
//     message: "",
//     btntext: "Close",
//     title: "Success",
//   });
//   const [isModalOpen, setIsModalOpen] = useState({ show: false });
//   const [isHistoryOpen, setIsHistoryOpen] = useState({ show: false });
//   const [isExcelOpen, setIsExcelOpen] = useState({ show: false });
//   const [isEmaillOpen, setIsEmaillOpen] = useState({
//     title: "",
//     show: false,
//     row: "",
//     skuData: "",
//     defaultSubject: "",
//     Quote_No: "",
//     ORDERID: "",
//     toEmail: "",
//     toName: "",
//   });
//   const [isEmailQuoteOpen, setIsEmailQuoteOpen] = useState({
//     show: false,
//     Quote_No: "",
//     order_id: "",
//   });
//   const [isEmailHistoryOpen, setIsEmailHistoryOpen] = useState({
//     show: false,
//     order_id: "",
//   });
//   const [isViewOpen, setIsViewOpen] = useState({
//     show: false,
//     order: [],
//     isStatusUpdate: false,
//   });

//   const user = useSelector((state) => state.auth.user);
//   const navigate = useNavigate();
//   const tableWrapperRefs = useRef({});

//   const generateStageKey = (statusKey, stageValue) =>
//     `${statusKey}_${stageValue}`;

//   // sync default active tabs when parent data changes
//   useEffect(() => {
//     const tabs = {};
//     Object.entries(data || {}).forEach(([statusKey, statusObj]) => {
//       const first = statusObj?.stage?.[0];
//       if (first) tabs[statusKey] = first.value;
//     });
//     setActiveTabs(tabs);
//   }, [data]);

//   // ---------- helpers ----------
//   const getProgressPercentage = (cardData) => {
//     if (!Array.isArray(cardData) || cardData.length === 0) return 0;
//     const active = cardData.filter((i) => !i.is_deleted);
//     if (active.length === 0) return 0;
//     return Math.round(
//       (active.filter((i) => i.check_status).length / active.length) * 100
//     );
//   };

//   const getOverdueClass = (dateString) => {
//     if (!dateString) return "";
//     const estimatedDate = new Date(dateString);
//     const today = new Date();
//     estimatedDate.setHours(0, 0, 0, 0);
//     today.setHours(0, 0, 0, 0);
//     const daysOverdue = Math.floor(
//       (today - estimatedDate) / (1000 * 60 * 60 * 24)
//     );
//     if (daysOverdue >= 21) return "bg-forred";
//     if (daysOverdue >= 10) return "bg-fororange";
//     if (daysOverdue >= 2) return "bg-overdate";
//     return "";
//   };

//   const triggerCardHighlight = (orderId) => {
//     setHighlightedOrders((prev) => [...prev, orderId]);
//     setTimeout(() => {
//       setHighlightedOrders((prev) => prev.filter((id) => id !== orderId));
//     }, 3000);
//   };

//   const toggleDropdown = (id, wrapperKey) => {
//     const isOpening = openDropdown !== id;
//     setOpenDropdown(isOpening ? id : null);
//     Object.entries(tableWrapperRefs.current).forEach(([key, el]) => {
//       if (!el) return;
//       el.style.overflow = key === wrapperKey && isOpening ? "visible" : "auto";
//     });
//   };

//   const handleDropdownAction = (wrapperKey, action) => {
//     setOpenDropdown(null);
//     if (tableWrapperRefs.current[wrapperKey]) {
//       tableWrapperRefs.current[wrapperKey].style.overflow = "auto";
//     }
//     action();
//   };

//   const handleViewClick = (row) => {
//     setIsViewOpen({ show: true, order: row, isStatusUpdate: false });
//     const newUrl = `${window.location.pathname}?${row.order_id}`;
//     window.history.pushState(null, "", newUrl);
//   };

//   const handleORDERRVERSION_OPEN = (e, order) => {
//     setOrderSku(order);
//     setIsModalOpen({ show: true });
//   };

//   const PD = new Date();
//   const today = new Intl.DateTimeFormat("en-US", {
//     dateStyle: "medium",
//   }).format(PD);

//   const HandlePDFClick = async (row) => {
//     const OP_arr = String(`order`)
//       .split(".")
//       .map((s) => s.charAt(0).toUpperCase() + s.slice(1));
//     const updatedInvoiceData = {
//       invoice_num: String(row.order_id),
//       Contract_Vehicle: row.ContractType?.name,
//       KO_name: row.orderKo?.name,
//       KO_email: row.orderKo?.email,
//       KO_phone: row.orderKo?.phone,
//       KO_address: row.orderKo?.address,
//       Print_Date: String(today),
//       trans_date: String(row.updated_at).split("T")[0],
//       estimated_date: row.estimated_date,
//       Address:
//         "ASPETTO INC, 150 Riverside pkwy. Suite 203. Fredericksburg, VA 22406 USA",
//       items: row.OrderProductSales,
//       Tax: row.tax,
//       Shipping_Cost: row.shipping_cost,
//       Total_Cost: row.total_cost_after_margin,
//       Other_Cost: row.other_cost_json,
//       BillTo_Phone: row.orderBilling?.phone,
//       BillTo_Name: row.orderBilling?.name,
//       BillTo_Address: row.orderBilling?.address,
//       BillTo_Email: row.orderBilling?.email,
//       Shipping_Details: {
//         Organization_Name: row?.organization_name,
//         KO_name: row.orderKo?.name,
//         Sales_Head_Info: {
//           Name: row.sales_lead_name,
//           Email: row.sales_lead_email,
//           Phone: row.sales_lead_phone,
//         },
//         Customer_Name: row.orderShipping?.name,
//         Customer_Email: row.orderShipping?.email,
//         Customer_Phone: row.orderShipping?.phone,
//         Customer_Address: row.orderShipping?.address,
//         Shipping_Method: row.shipping_method,
//         Shipping_Method_Detail: row.shipping_method_detail,
//         Shipping_Terms: row.shipping_term,
//         Estimated_Delivery: row.estimated_delivery,
//         Payment_Terms: row.payment_term,
//         Payment_Terms_Details: row.payment_term_detail,
//       },
//     };
//     setTimeout(async () => {
//       const pdfBlob = await pdf(
//         <PdfDocument invoicedata={updatedInvoiceData} />
//       ).toBlob();
//       const url = URL.createObjectURL(pdfBlob);
//       const a = document.createElement("a");
//       a.href = url;
//       a.download = `${OP_arr.join(" ")} ${String(row.invoice_no).split(".")[0]}.pdf`;
//       document.body.appendChild(a);
//       a.click();
//       document.body.removeChild(a);
//       URL.revokeObjectURL(url);
//     }, 0);
//   };

//   // ---------- excel ----------
//   const getAllRows = () =>
//     Object.values(data).flatMap((s) =>
//       (s?.stage || []).flatMap((st) => st.data || [])
//     );

//   const handleGenerateExcel = (selectedFields) => {
//     try {
//       const excelData = getAllRows();
//       if (!excelData.length) throw new Error("No data available to export");
//       if (!selectedFields?.length)
//         throw new Error("No fields selected for export");

//       const formattedData = excelData.map((row) => {
//         const filteredRow = {};
//         selectedFields.forEach((field) => {
//           switch (field) {
//             case "Order Type":
//               filteredRow[field] = row?.order_type || "";
//               break;
//             case "Order ID":
//               filteredRow[field] = row.order_id || "";
//               break;
//             case "Contract Vehicle":
//               filteredRow[field] = row.ContractType?.name || "";
//               break;
//             case "KO name":
//               filteredRow[field] = row.orderKo?.name || "";
//               break;
//             case "KO email":
//               filteredRow[field] = row.orderKo?.email || "";
//               break;
//             case "KO phone":
//               filteredRow[field] = row.orderKo?.phone || "";
//               break;
//             case "KO address":
//               filteredRow[field] = row.orderKo?.address || "";
//               break;
//             case "Date Created":
//             case "Created Date":
//               filteredRow[field] = row.published_date
//                 ? moment(row.published_date).format("MM/DD/YYYY")
//                 : "";
//               break;
//             case "Estimated Date Fulfilled":
//               filteredRow[field] = row.estimated_date
//                 ? moment(row.estimated_date).format("MM/DD/YYYY")
//                 : "";
//               break;
//             case "Actual Date Fulfilled":
//               filteredRow[field] = row.actual_date
//                 ? moment(row.actual_date).format("MM/DD/YYYY")
//                 : "";
//               break;
//             case "Order Description":
//               filteredRow[field] = row.brief;
//               break;
//             case "Organization Name":
//               filteredRow[field] = row.organization_name;
//               break;
//             case "Customer Name":
//               filteredRow[field] = row.orderShipping?.name;
//               break;
//             case "Customer Email":
//               filteredRow[field] = row.orderShipping?.email;
//               break;
//             case "Customer Phone":
//               filteredRow[field] = row.orderShipping?.phone;
//               break;
//             case "Customer Address":
//               filteredRow[field] = row.orderShipping?.address;
//               break;
//             case "Shipping Method":
//               filteredRow[field] = row.shipping_method;
//               break;
//             case "Sales Head Name":
//               filteredRow[field] = row.sales_lead_name;
//               break;
//             case "Sales Head Email":
//               filteredRow[field] = row.sales_lead_email;
//               break;
//             case "Sales Head Ph":
//               filteredRow[field] = row.sales_lead_phone;
//               break;
//             case "Shipping Terms":
//               filteredRow[field] = row.shipping_term || "";
//               break;
//             case "Estimated Delivery":
//               filteredRow[field] = row.estimated_delivery;
//               break;
//             case "Payment Terms": {
//               const term = TERMS.Term.find((t) => t.Id === row.payment_term);
//               if (term) filteredRow[field] = term.Name;
//               break;
//             }
//             case "Other Cost":
//             case "Custom Field": {
//               if (row.other_cost_json) {
//                 try {
//                   const otherCosts = Array.isArray(row.other_cost_json)
//                     ? row.other_cost_json
//                     : JSON.parse(row.other_cost_json);
//                   otherCosts.forEach((cost, idx) => {
//                     if (cost.Name)
//                       filteredRow[`Other Cost Name${idx + 1}`] = cost.Name;
//                     if (cost.Amount)
//                       filteredRow[`Other Cost ${idx + 1}($)`] = cost.Amount;
//                   });
//                 } catch (e) {
//                   console.error("Error parsing other_cost_json:", e);
//                 }
//               }
//               break;
//             }
//             case "Shipping Cost($)":
//               filteredRow[field] = row.shipping_cost;
//               break;
//             case "Tax($)":
//               filteredRow[field] = row.tax;
//               break;
//             case "Total Cost Before Margin($)":
//               filteredRow[field] = row.total_cost_before_margin;
//               break;
//             case "Total Cost After Margin($)":
//               filteredRow[field] = row.total_cost_after_margin;
//               break;
//             case "Last Updated Date":
//               filteredRow[field] = row.updated_at
//                 ? moment(row.updated_at).format("MM/DD/YYYY")
//                 : "";
//               break;
//             case "Status":
//               filteredRow[field] = row.status;
//               break;
//             default:
//               filteredRow[field] = "";
//           }
//         });
//         return filteredRow;
//       });

//       const wb = XLSX.utils.book_new();
//       const ws = XLSX.utils.json_to_sheet(formattedData);
//       XLSX.utils.book_append_sheet(wb, ws, "ASPETTO SALES");
//       XLSX.writeFile(
//         wb,
//         "ASPETTO SALES-" + String(new Date()).split("T")[0] + ".xlsx"
//       );
//     } catch (error) {
//       toast.error(error.message);
//     }
//   };

//   // ---------- row dropdown ----------
//   const renderActionDropdown = (row, rowId, wrapperKey) => (
//     <td style={{ position: "relative" }}>
//       <button
//         onClick={() => toggleDropdown(rowId, wrapperKey)}
//         style={{ background: "transparent", border: "none", cursor: "pointer" }}
//       >
//         <IconDotsVertical size={20} />
//       </button>
//       {openDropdown === rowId && (
//         <ul className="order-dropdown-menu p-0">
//           <li
//             className="dropdown-item"
//             onClick={() =>
//               handleDropdownAction(wrapperKey, () =>
//                 navigate(`/edit-order/${row?.order_id}`)
//               )
//             }
//           >
//             <span>
//               {canRequestOrderChange(row?.status) ? <IconEye stroke={1} /> : <IconPencil stroke={1} />}{" "}{canRequestOrderChange(row?.status) ? "Change Request" : "Edit Order"}
//             </span>
//             <IconChevronRight stroke={1} />
//           </li>
//           <li
//             className="dropdown-item border-top"
//             onClick={() =>
//               handleDropdownAction(wrapperKey, () => handleViewClick(row))
//             }
//           >
//             <span>
//               <IconEye stroke={1} /> View Order
//             </span>
//             <IconChevronRight stroke={1} />
//           </li>
//           <li
//             className="dropdown-item border-top"
//             onClick={() =>
//               handleDropdownAction(wrapperKey, () =>
//                 handleORDERRVERSION_OPEN(null, row.order_id)
//               )
//             }
//           >
//             <span>
//               <IconHistoryToggle stroke={1} /> Changes
//             </span>
//             <IconChevronRight stroke={1} />
//           </li>
//           <li
//             className="dropdown-item border-top"
//             onClick={() =>
//               handleDropdownAction(wrapperKey, () => HandlePDFClick(row))
//             }
//           >
//             <span>
//               <IconFileTypePdf stroke={1} /> PDF
//             </span>
//             <IconChevronRight stroke={1} />
//           </li>
//           <li
//             className="dropdown-item border-top"
//             onClick={() =>
//               handleDropdownAction(wrapperKey, () =>
//                 setIsEmailHistoryOpen({ show: true, order_id: row.order_id })
//               )
//             }
//           >
//             <span>
//               <IconMailSpark stroke={1} /> Email
//             </span>
//             <IconChevronRight stroke={1} />
//           </li>
//           <li className="border-top">
//             <div className="rfq_lis_short justify-content-center p-2">
//               <span>
//                 <IconBox stroke={1} /> {row.product_count}
//               </span>
//               <span>
//                 <IconPaperclip stroke={1} /> {row.attachment_count}
//               </span>
//               <span>
//                 <IconMessageCircle stroke={1} /> {row.notes_count}
//               </span>
//             </div>
//           </li>
//         </ul>
//       )}
//     </td>
//   );

//   const renderStageTable = (statusKey, stage) => {
//     const wrapperKey = `${statusKey}|${stage.value}`;
//     const stageKey = generateStageKey(statusKey, stage.value);
//     const rows = stage?.data || [];
//     const isStageLoading = loadingStates[stageKey] || false;
//     const hasMore = hasMoreData[stageKey] !== false;
//     return (
//       <div
//         className="table-responsive mail_wrapper border-0 p-0"
//         ref={(el) => (tableWrapperRefs.current[wrapperKey] = el)}
//         style={{ overflowX: "auto" }}
//       >
//         <table className="table">
//           <thead>
//             <tr>
//               <th>Order ID</th>
//               <th>Sales Lead</th>
//               <th>Contract Vehicle</th>
//               <th>Created Date</th>
//               <th>Due Date</th>
//               <th>Type</th>
//               <th>Total Cost</th>
//               <th>Up Next</th>
//               <th>Action</th>
//             </tr>
//           </thead>
//           <tbody>
//             {rows.length > 0 ? (
//               rows.map((row, index) => {
//                 const overdueClass = getOverdueClass(row?.estimated_date);
//                 const progress = getProgressPercentage(
//                   row?.OrderChainOfCustodies
//                 );
//                 const rowId = `${wrapperKey}-${row.order_id}-${index}`;
//                 return (
//                   <tr
//                     key={row.invoice_no || index}
//                     className={`align-middle ${overdueClass} ${
//                       highlightedOrders.includes(row.order_id)
//                         ? "highlight-pending"
//                         : ""
//                     }`}
//                   >
//                     <td>{row.order_id}</td>
//                     <td>{row?.sales_lead_name || "N/A"}</td>
//                     <td>{row?.ContractType?.name || "N/A"}</td>
//                     <td>{moment(row?.published_date).format("MM/DD/YYYY")}</td>
//                     <td>{moment(row?.estimated_date).format("MM/DD/YYYY")}</td>
//                     <td>
//                       {ORDER_TYPE_MAP[row?.order_type] ||
//                         row?.order_type ||
//                         "N/A"}
//                     </td>
//                     <td className="text-primary">
//                       ${row?.total_cost_after_margin}
//                     </td>
//                     <td>
//                       <div>
//                         <div className="d-flex gap-1">
//                           <p className="mb-1 text-dark">
//                             {row?.coc_next_step || "No steps available"}
//                           </p>
//                         </div>
//                         <ProgressBar
//                           variant="warning"
//                           now={progress}
//                           style={{ height: "6px", width: "100%" }}
//                         />
//                       </div>
//                     </td>
//                     {renderActionDropdown(row, rowId, wrapperKey)}
//                   </tr>
//                 );
//               })
//             ) : (
//               <tr>
//                 <td colSpan="9" className="text-center border-0">
//                   No data found.
//                 </td>
//               </tr>
//             )}
//           </tbody>
//         </table>
//         {hasMore && rows.length >= limit && (
//           <div className="text-center mt-3">
//             <Button
//               variant="outline-primary"
//               onClick={() => onLoadMore && onLoadMore(statusKey, stage)}
//               disabled={isStageLoading}
//             >
//               {isStageLoading ? "Loading..." : "Load More"}
//             </Button>
//           </div>
//         )}
//       </div>
//     );
//   };

//   return (
//     <>
//       {isHistoryOpen.show && (
//         <GetOrderHistoryDialog
//           orderSku={orderSku}
//           show={isHistoryOpen.show}
//           setShow={setIsHistoryOpen}
//         />
//       )}
//       {isModalOpen.show && (
//         <Product_Revistion_order
//           orderSku={orderSku}
//           show={isModalOpen.show}
//           setShow={setIsModalOpen}
//         />
//       )}
//       {isEmailQuoteOpen.show && (
//         <EmailQuoteDialogOrder
//           username={user.username}
//           show={isEmailQuoteOpen.show}
//           order_id={isEmailQuoteOpen.order_id}
//           setShow={setIsEmailQuoteOpen}
//           setIsSuccsessModalOpen={setIsSuccsessModalOpen}
//         />
//       )}
//       {isEmailHistoryOpen.show && (
//         <EmailHistoryOrder
//           username={user.username}
//           show={isEmailHistoryOpen.show}
//           order_id={isEmailHistoryOpen.order_id}
//           setShow={setIsEmailHistoryOpen}
//           setIsSuccsessModalOpen={setIsSuccsessModalOpen}
//         />
//       )}
//       {isViewOpen.show && (
//         <View_DetailsLifecycle
//           show={isViewOpen.show}
//           setShow={setIsViewOpen}
//           order={isViewOpen.order}
//           isStatusUpdate={isViewOpen.isStatusUpdate}
//           onStatusUpdate={() => {
//             setIsViewOpen((prev) => ({ ...prev, isStatusUpdate: true }));
//             onRefresh && onRefresh();
//           }}
//           triggerCardHighlight={triggerCardHighlight}
//         />
//       )}
//       {isEmaillOpen.show && (
//         <OrderKOorCustomerEmailDialog
//           pagetitle={isEmaillOpen.title}
//           toEmail={isEmaillOpen.toEmail}
//           toName={isEmaillOpen.toName}
//           ORDERID={isEmaillOpen.ORDERID}
//           show={isEmaillOpen.show}
//           skuData={isEmaillOpen.skuData}
//           row={isEmaillOpen.row}
//           defaultSubject={isEmaillOpen.defaultSubject}
//           Quote_No={isEmaillOpen.Quote_No}
//           setShow={setIsEmaillOpen}
//           setIsSuccsessModalOpen={setIsSuccsessModalOpen}
//         />
//       )}
//       {isExcelOpen.show && (
//         <ExcelDialogOrder
//           show={isExcelOpen.show}
//           setShow={setIsExcelOpen}
//           onDownload={(fields) => {
//             handleGenerateExcel(fields);
//             setIsExcelOpen({ show: false });
//           }}
//         />
//       )}
//       <SuccsessMsgModal
//         show={isSuccsessModalOpen.show}
//         onHide={() =>
//           setIsSuccsessModalOpen({ ...isSuccsessModalOpen, show: false })
//         }
//         title={isSuccsessModalOpen?.title}
//         btntext={isSuccsessModalOpen?.btntext}
//         message={isSuccsessModalOpen?.message}
//       />

//       <div className="order_list_view">
//         {Object.keys(data).length === 0 ? (
//           <div className="text-center p-4">Loading...</div>
//         ) : (
//           <Accordion defaultActiveKey="0">
//             {Object.entries(data).map(([statusKey, statusObj], idx) => {
//               const stages = statusObj?.stage || [];
//               const activeStageValue = activeTabs[statusKey] ?? stages[0]?.value;
//               const activeStage =
//                 stages.find((s) => s.value === activeStageValue) || stages[0];
//               const totalCount = stages.reduce(
//                 (sum, s) => sum + (s.total || 0),
//                 0
//               );
//               const color = STATUS_COLORS[statusKey] || "#8A97AB";
//               return (
//                 <Accordion.Item
//                   eventKey={String(idx)}
//                   key={statusKey}
//                   className="border-0"
//                 >
//                   <Accordion.Header>
//                     <div className="d-flex justify-content-between align-items-center w-100">
//                       <span className="order_status_box">
//                         {statusObj.display_name}{" "}
//                         <b style={badgeStyle(color)}>{totalCount}</b>
//                       </span>
//                       {stages.length > 1 && (
//                         <div
//                           className="table_tabs_group d-flex gap-2"
//                           onClick={(e) => e.stopPropagation()}
//                         >
//                           {stages.map((s) => (
//                             <button
//                               key={s.value}
//                               type="button"
//                               className={`btn btn-sm ${
//                                 activeStageValue === s.value
//                                   ? "btn-warning text-white"
//                                   : "btn-outline-secondary"
//                               }`}
//                               onClick={(e) => {
//                                 e.stopPropagation();
//                                 setActiveTabs((prev) => ({
//                                   ...prev,
//                                   [statusKey]: s.value,
//                                 }));
//                               }}
//                             >
//                               {s.display_name} ({s.total || 0})
//                             </button>
//                           ))}
//                         </div>
//                       )}
//                     </div>
//                   </Accordion.Header>
//                   <Accordion.Body>
//                     {activeStage && renderStageTable(statusKey, activeStage)}
//                   </Accordion.Body>
//                 </Accordion.Item>
//               );
//             })}
//           </Accordion>
//         )}
//       </div>
//     </>
//   );
// };

// export default TableListingNew;


// new code.....
import React, { useEffect, useRef, useState } from "react";
import { TERMS } from "../../constant/_constant";
import * as XLSX from "xlsx";
import { Button, ProgressBar, Accordion } from "react-bootstrap";
import { pdf } from "@react-pdf/renderer";
import {
  IconPaperclip,
  IconDotsVertical,
  IconPencil,
  IconEye,
  IconHistoryToggle,
  IconFileTypePdf,
  IconMailSpark,
  IconBox,
  IconMessageCircle,
  IconChevronRight,
} from "@tabler/icons-react";
import moment from "moment";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import PdfDocument from "./PDF/main";
import SuccsessMsgModal from "../../components/SuccessMsgModal";
import GetOrderHistoryDialog from "./GetOrderHistoryDialog";
import OrderChangeHistoryModal from "./ChangeHistory/OrderChangeHistoryModal";
import { canRequestOrderChange } from "../ChangeRequests/orderLock";
import useOrderChangeAccess from "../ChangeRequests/useOrderChangeAccess";
import EmailQuoteDialogOrder from "./Email/EmailQuoteDialogOrder";
import EmailHistoryOrder from "./Email/EmailHistoryOrder";
import OrderKOorCustomerEmailDialog from "./Email/OrderKOorCustomerEmailDialog";
import ExcelDialogOrder from "./ExcelDialogOrder";
import View_DetailsLifecycle from "./ViewDetail/View_DetailsLifecycle";

const STATUS_COLORS = {
  DRAFT: "#8A97AB",
  PENDING: "#F59F00",
  "IN PROGRESS": "#066FD1",
  REACHED_WAREHOUSE: "#305edf",
  SHIPPED: "#AE3EC9",
  DELIVERED: "#42ad9f",
  PAID_CLOSED: "#06a159",
  LOST_CANCELLED: "#D63939",
};

const ORDER_TYPE_MAP = {
  DS: "Dropship",
  CRK: "Consolidate / Repack / Kit",
  M: "Manufacturing",
  KIT: "Kit",
};

const badgeStyle = (color) => ({
  backgroundColor: color,
  color: "#fff",
  borderRadius: "10px",
  padding: "2px 12px",
  fontSize: "14px",
  display: "inline-block",
});

const TableListingNew = ({
  data = {},
  limit = 10,
  loadingStates = {},
  hasMoreData = {},
  onLoadMore,
  onRefresh,
}) => {
  /* Super admin / the two approvers keep the normal Edit action. */
  useOrderChangeAccess();
  // const [activeTabs, setActiveTabs] = useState({});
  const [highlightedOrders, setHighlightedOrders] = useState([]);
  const [openDropdown, setOpenDropdown] = useState(null);
  const [orderSku, setOrderSku] = useState("");

  const [isSuccsessModalOpen, setIsSuccsessModalOpen] = useState({
    show: false,
    message: "",
    btntext: "Close",
    title: "Success",
  });
  const [isModalOpen, setIsModalOpen] = useState({ show: false });
  const [isHistoryOpen, setIsHistoryOpen] = useState({ show: false });
  const [isExcelOpen, setIsExcelOpen] = useState({ show: false });
  const [isEmaillOpen, setIsEmaillOpen] = useState({
    title: "",
    show: false,
    row: "",
    skuData: "",
    defaultSubject: "",
    Quote_No: "",
    ORDERID: "",
    toEmail: "",
    toName: "",
  });
  const [isEmailQuoteOpen, setIsEmailQuoteOpen] = useState({
    show: false,
    Quote_No: "",
    order_id: "",
  });
  const [isEmailHistoryOpen, setIsEmailHistoryOpen] = useState({
    show: false,
    order_id: "",
  });
  const [isViewOpen, setIsViewOpen] = useState({
    show: false,
    order: [],
    isStatusUpdate: false,
  });

  const user = useSelector((state) => state.auth.user);
  const navigate = useNavigate();
  const tableWrapperRefs = useRef({});

  const generateStageKey = (statusKey, stageValue) =>
    `${statusKey}_${stageValue}`;

  // --- add states ---
  const [activeTabs, setActiveTabs] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("orderListActiveTabs") || "{}");
    } catch {
      return {};
    }
  });
  const [openAccordions, setOpenAccordions] = useState(() => {
    try {
      return JSON.parse(
        localStorage.getItem("orderListOpenAccordions") || '["0"]'
      );
    } catch {
      return ["0"];
    }
  });

  // ---activeTabs sync effect ---
  // useEffect(() => {
  //   const tabs = { ...activeTabs };
  //   let changed = false;
  //   Object.entries(data || {}).forEach(([statusKey, statusObj]) => {
  //     const stages = statusObj?.stage || [];
  //     const saved = tabs[statusKey];
  //     // keep saved tab only if it still exists in fresh data
  //     if (!saved || !stages.some((s) => s.value === saved)) {
  //       const first = stages[0];
  //       if (first) {
  //         tabs[statusKey] = first.value;
  //         changed = true;
  //       }
  //     }
  //   });
  //   if (changed) setActiveTabs(tabs);
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [data]);

  // --- helpers ---
  const handleTabSelect = (statusKey, value) => {
    setActiveTabs((prev) => {
      const next = { ...prev, [statusKey]: value };
      localStorage.setItem("orderListActiveTabs", JSON.stringify(next));
      return next;
    });
  };

  const handleAccordionSelect = (keys) => {
    const next = Array.isArray(keys) ? keys : keys != null ? [keys] : [];
    setOpenAccordions(next);
    localStorage.setItem("orderListOpenAccordions", JSON.stringify(next));
  };

  // ---------- helpers ----------
  const getProgressPercentage = (cardData) => {
    if (!Array.isArray(cardData) || cardData.length === 0) return 0;
    const active = cardData.filter((i) => !i.is_deleted);
    if (active.length === 0) return 0;
    return Math.round(
      (active.filter((i) => i.check_status).length / active.length) * 100
    );
  };

  const getOverdueClass = (dateString) => {
    if (!dateString) return "";
    const estimatedDate = new Date(dateString);
    const today = new Date();
    estimatedDate.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);
    const daysOverdue = Math.floor(
      (today - estimatedDate) / (1000 * 60 * 60 * 24)
    );
    if (daysOverdue >= 21) return "bg-forred";
    if (daysOverdue >= 10) return "bg-fororange";
    if (daysOverdue >= 2) return "bg-overdate";
    return "";
  };

  const triggerCardHighlight = (orderId) => {
    setHighlightedOrders((prev) => [...prev, orderId]);
    setTimeout(() => {
      setHighlightedOrders((prev) => prev.filter((id) => id !== orderId));
    }, 3000);
  };

  const toggleDropdown = (id, wrapperKey) => {
    const isOpening = openDropdown !== id;
    setOpenDropdown(isOpening ? id : null);
    Object.entries(tableWrapperRefs.current).forEach(([key, el]) => {
      if (!el) return;
      el.style.overflow = key === wrapperKey && isOpening ? "visible" : "auto";
    });
  };

  const handleDropdownAction = (wrapperKey, action) => {
    setOpenDropdown(null);
    if (tableWrapperRefs.current[wrapperKey]) {
      tableWrapperRefs.current[wrapperKey].style.overflow = "auto";
    }
    action();
  };

  const handleViewClick = (row) => {
    setIsViewOpen({ show: true, order: row, isStatusUpdate: false });
    const newUrl = `${window.location.pathname}?${row.order_id}`;
    window.history.pushState(null, "", newUrl);
  };

  const handleORDERRVERSION_OPEN = (e, order) => {
    setOrderSku(order);
    setIsModalOpen({ show: true });
  };

  const PD = new Date();
  const today = new Intl.DateTimeFormat("en-US", {
    dateStyle: "medium",
  }).format(PD);

  const HandlePDFClick = async (row) => {
    const OP_arr = String(`order`)
      .split(".")
      .map((s) => s.charAt(0).toUpperCase() + s.slice(1));
    const updatedInvoiceData = {
      invoice_num: String(row.order_id),
      Contract_Vehicle: row.ContractType?.name,
      KO_name: row.orderKo?.name,
      KO_email: row.orderKo?.email,
      KO_phone: row.orderKo?.phone,
      KO_address: row.orderKo?.address,
      Print_Date: String(today),
      trans_date: String(row.updated_at).split("T")[0],
      estimated_date: row.estimated_date,
      Address:
        "ASPETTO INC, 150 Riverside pkwy. Suite 203. Fredericksburg, VA 22406 USA",
      items: row.OrderProductSales,
      Tax: row.tax,
      Shipping_Cost: row.shipping_cost,
      Total_Cost: row.total_cost_after_margin,
      Other_Cost: row.other_cost_json,
      BillTo_Phone: row.orderBilling?.phone,
      BillTo_Name: row.orderBilling?.name,
      BillTo_Address: row.orderBilling?.address,
      BillTo_Email: row.orderBilling?.email,
      Shipping_Details: {
        Organization_Name: row?.organization_name,
        KO_name: row.orderKo?.name,
        Sales_Head_Info: {
          Name: row.sales_lead_name,
          Email: row.sales_lead_email,
          Phone: row.sales_lead_phone,
        },
        Customer_Name: row.orderShipping?.name,
        Customer_Email: row.orderShipping?.email,
        Customer_Phone: row.orderShipping?.phone,
        Customer_Address: row.orderShipping?.address,
        Shipping_Method: row.shipping_method,
        Shipping_Method_Detail: row.shipping_method_detail,
        Shipping_Terms: row.shipping_term,
        Estimated_Delivery: row.estimated_delivery,
        Payment_Terms: row.payment_term,
        Payment_Terms_Details: row.payment_term_detail,
      },
    };
    setTimeout(async () => {
      const pdfBlob = await pdf(
        <PdfDocument invoicedata={updatedInvoiceData} />
      ).toBlob();
      const url = URL.createObjectURL(pdfBlob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `${OP_arr.join(" ")} ${String(row.invoice_no).split(".")[0]}.pdf`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    }, 0);
  };

  // ---------- excel ----------
  const getAllRows = () =>
    Object.values(data).flatMap((s) =>
      (s?.stage || []).flatMap((st) => st.data || [])
    );

  const handleGenerateExcel = (selectedFields) => {
    try {
      const excelData = getAllRows();
      if (!excelData.length) throw new Error("No data available to export");
      if (!selectedFields?.length)
        throw new Error("No fields selected for export");

      const formattedData = excelData.map((row) => {
        const filteredRow = {};
        selectedFields.forEach((field) => {
          switch (field) {
            case "Order Type":
              filteredRow[field] = row?.order_type || "";
              break;
            case "Order ID":
              filteredRow[field] = row.order_id || "";
              break;
            case "Contract Vehicle":
              filteredRow[field] = row.ContractType?.name || "";
              break;
            case "KO name":
              filteredRow[field] = row.orderKo?.name || "";
              break;
            case "KO email":
              filteredRow[field] = row.orderKo?.email || "";
              break;
            case "KO phone":
              filteredRow[field] = row.orderKo?.phone || "";
              break;
            case "KO address":
              filteredRow[field] = row.orderKo?.address || "";
              break;
            case "Date Created":
            case "Created Date":
              filteredRow[field] = row.published_date
                ? moment(row.published_date).format("MM/DD/YYYY")
                : "";
              break;
            case "Estimated Date Fulfilled":
              filteredRow[field] = row.estimated_date
                ? moment(row.estimated_date).format("MM/DD/YYYY")
                : "";
              break;
            case "Actual Date Fulfilled":
              filteredRow[field] = row.actual_date
                ? moment(row.actual_date).format("MM/DD/YYYY")
                : "";
              break;
            case "Order Description":
              filteredRow[field] = row.brief;
              break;
            case "Organization Name":
              filteredRow[field] = row.organization_name;
              break;
            case "Customer Name":
              filteredRow[field] = row.orderShipping?.name;
              break;
            case "Customer Email":
              filteredRow[field] = row.orderShipping?.email;
              break;
            case "Customer Phone":
              filteredRow[field] = row.orderShipping?.phone;
              break;
            case "Customer Address":
              filteredRow[field] = row.orderShipping?.address;
              break;
            case "Shipping Method":
              filteredRow[field] = row.shipping_method;
              break;
            case "Sales Head Name":
              filteredRow[field] = row.sales_lead_name;
              break;
            case "Sales Head Email":
              filteredRow[field] = row.sales_lead_email;
              break;
            case "Sales Head Ph":
              filteredRow[field] = row.sales_lead_phone;
              break;
            case "Shipping Terms":
              filteredRow[field] = row.shipping_term || "";
              break;
            case "Estimated Delivery":
              filteredRow[field] = row.estimated_delivery;
              break;
            case "Payment Terms": {
              const term = TERMS.Term.find((t) => t.Id === row.payment_term);
              if (term) filteredRow[field] = term.Name;
              break;
            }
            case "Other Cost":
            case "Custom Field": {
              if (row.other_cost_json) {
                try {
                  const otherCosts = Array.isArray(row.other_cost_json)
                    ? row.other_cost_json
                    : JSON.parse(row.other_cost_json);
                  otherCosts.forEach((cost, idx) => {
                    if (cost.Name)
                      filteredRow[`Other Cost Name${idx + 1}`] = cost.Name;
                    if (cost.Amount)
                      filteredRow[`Other Cost ${idx + 1}($)`] = cost.Amount;
                  });
                } catch (e) {
                  console.error("Error parsing other_cost_json:", e);
                }
              }
              break;
            }
            case "Shipping Cost($)":
              filteredRow[field] = row.shipping_cost;
              break;
            case "Tax($)":
              filteredRow[field] = row.tax;
              break;
            case "Total Cost Before Margin($)":
              filteredRow[field] = row.total_cost_before_margin;
              break;
            case "Total Cost After Margin($)":
              filteredRow[field] = row.total_cost_after_margin;
              break;
            case "Last Updated Date":
              filteredRow[field] = row.updated_at
                ? moment(row.updated_at).format("MM/DD/YYYY")
                : "";
              break;
            case "Status":
              filteredRow[field] = row.status;
              break;
            default:
              filteredRow[field] = "";
          }
        });
        return filteredRow;
      });

      const wb = XLSX.utils.book_new();
      const ws = XLSX.utils.json_to_sheet(formattedData);
      XLSX.utils.book_append_sheet(wb, ws, "ASPETTO SALES");
      XLSX.writeFile(
        wb,
        "ASPETTO SALES-" + String(new Date()).split("T")[0] + ".xlsx"
      );
    } catch (error) {
      toast.error(error.message);
    }
  };

  // ---------- row dropdown ----------
  const renderActionDropdown = (row, rowId, wrapperKey) => (
    <td style={{ position: "relative" }}>
      <button
        onClick={() => toggleDropdown(rowId, wrapperKey)}
        style={{ background: "transparent", border: "none", cursor: "pointer" }}
      >
        <IconDotsVertical size={20} />
      </button>
      {openDropdown === rowId && (
        <ul className="order-dropdown-menu p-0">
          <li
            className="dropdown-item"
            style={{ cursor: "pointer" }}
            onClick={() =>
              handleDropdownAction(wrapperKey, () =>
                navigate(`/edit-order/${row?.order_id}`)
              )
            }
          >
            <span>
              {canRequestOrderChange(row?.status) ? <IconEye stroke={1} /> : <IconPencil stroke={1} />}{" "}{canRequestOrderChange(row?.status) ? "Change Request" : "Edit Order"}
            </span>
            <IconChevronRight stroke={1} />
          </li>
          <li
            className="dropdown-item border-top"
            style={{ cursor: "pointer" }}
            onClick={() =>
              handleDropdownAction(wrapperKey, () => handleViewClick(row))
            }
          >
            <span>
              <IconEye stroke={1} /> View Order
            </span>
            <IconChevronRight stroke={1} />
          </li>
          <li
            className="dropdown-item border-top"
            style={{ cursor: "pointer" }}
            onClick={() =>
              handleDropdownAction(wrapperKey, () =>
                handleORDERRVERSION_OPEN(null, row.order_id)
              )
            }
          >
            <span>
              <IconHistoryToggle stroke={1} /> Changes
            </span>
            <IconChevronRight stroke={1} />
          </li>
          <li
            className="dropdown-item border-top"
            style={{ cursor: "pointer" }}
            onClick={() =>
              handleDropdownAction(wrapperKey, () => HandlePDFClick(row))
            }
          >
            <span>
              <IconFileTypePdf stroke={1} /> PDF
            </span>
            <IconChevronRight stroke={1} />
          </li>
          <li
            className="dropdown-item border-top"
            style={{ cursor: "pointer" }}
            onClick={() =>
              handleDropdownAction(wrapperKey, () =>
                setIsEmailHistoryOpen({ show: true, order_id: row.order_id })
              )
            }
          >
            <span>
              <IconMailSpark stroke={1} /> Email
            </span>
            <IconChevronRight stroke={1} />
          </li>
          <li className="border-top">
            <div className="rfq_lis_short justify-content-center p-2">
              <span>
                <IconBox stroke={1} /> {row.product_count}
              </span>
              <span>
                <IconPaperclip stroke={1} /> {row.attachment_count}
              </span>
              <span>
                <IconMessageCircle stroke={1} /> {row.notes_count}
              </span>
            </div>
          </li>
        </ul>
      )}
    </td>
  );

  const renderStageTable = (statusKey, stage) => {
    const wrapperKey = `${statusKey}|${stage.value}`;
    const stageKey = generateStageKey(statusKey, stage.value);
    const rows = stage?.data || [];
    const isStageLoading = loadingStates[stageKey] || false;
    const hasMore = hasMoreData[stageKey] !== false;
    return (
      <div
        className="table-responsive mail_wrapper border-0 p-0"
        ref={(el) => (tableWrapperRefs.current[wrapperKey] = el)}
        style={{ overflowX: "auto" }}
      >
        <table className="table">
          <thead>
            <tr>
              <th>Order ID</th>
              <th>Sales Lead</th>
              <th>Contract Vehicle</th>
              <th>Created Date</th>
              <th>Due Date</th>
              <th>Type</th>
              <th>Total Cost</th>
              <th>Up Next</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {rows.length > 0 ? (
              rows.map((row, index) => {
                const overdueClass = getOverdueClass(row?.estimated_date);
                const progress = getProgressPercentage(
                  row?.OrderChainOfCustodies
                );
                const rowId = `${wrapperKey}-${row.order_id}-${index}`;
                return (
                  <tr
                    key={row.invoice_no || index}
                    className={`align-middle ${overdueClass} ${highlightedOrders.includes(row.order_id)
                      ? "highlight-pending"
                      : ""
                      }`}
                  >
                    <td>{row.order_id}</td>
                    <td>{row?.sales_lead_name || "N/A"}</td>
                    <td>{row?.ContractType?.name || "N/A"}</td>
                    <td>{moment(row?.published_date).format("MM/DD/YYYY")}</td>
                    <td>{moment(row?.estimated_date).format("MM/DD/YYYY")}</td>
                    <td>
                      {ORDER_TYPE_MAP[row?.order_type] ||
                        row?.order_type ||
                        "N/A"}
                    </td>
                    <td className="text-primary">
                      ${row?.total_cost_after_margin}
                    </td>
                    <td>
                      <div>
                        <div className="d-flex gap-1">
                          <p className="mb-1 text-dark">
                            {row?.coc_next_step || "No steps available"}
                          </p>
                        </div>
                        <ProgressBar
                          variant="warning"
                          now={progress}
                          style={{ height: "6px", width: "100%" }}
                        />
                      </div>
                    </td>
                    {renderActionDropdown(row, rowId, wrapperKey)}
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan="9" className="text-center border-0">
                  No data found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
        {hasMore && rows.length >= limit && (
          <div className="text-center mt-3">
            <Button
              variant="outline-primary"
              onClick={() => onLoadMore && onLoadMore(statusKey, stage)}
              disabled={isStageLoading}
            >
              {isStageLoading ? "Loading..." : "Load More"}
            </Button>
          </div>
        )}
      </div>
    );
  };

  return (
    <>
      {isHistoryOpen.show && (
        <GetOrderHistoryDialog
          orderSku={orderSku}
          show={isHistoryOpen.show}
          setShow={setIsHistoryOpen}
        />
      )}
      {isModalOpen.show && (
        <OrderChangeHistoryModal
          orderSku={orderSku}
          show={isModalOpen.show}
          setShow={setIsModalOpen}
        />
      )}
      {isEmailQuoteOpen.show && (
        <EmailQuoteDialogOrder
          username={user.username}
          show={isEmailQuoteOpen.show}
          order_id={isEmailQuoteOpen.order_id}
          setShow={setIsEmailQuoteOpen}
          setIsSuccsessModalOpen={setIsSuccsessModalOpen}
        />
      )}
      {isEmailHistoryOpen.show && (
        <EmailHistoryOrder
          username={user.username}
          show={isEmailHistoryOpen.show}
          order_id={isEmailHistoryOpen.order_id}
          setShow={setIsEmailHistoryOpen}
          setIsSuccsessModalOpen={setIsSuccsessModalOpen}
        />
      )}
      {isViewOpen.show && (
        <View_DetailsLifecycle
          show={isViewOpen.show}
          setShow={setIsViewOpen}
          order={isViewOpen.order}
          isStatusUpdate={isViewOpen.isStatusUpdate}
          onStatusUpdate={() => {
            setIsViewOpen((prev) => ({ ...prev, isStatusUpdate: true }));
            onRefresh && onRefresh();
          }}
          triggerCardHighlight={triggerCardHighlight}
        />
      )}
      {isEmaillOpen.show && (
        <OrderKOorCustomerEmailDialog
          pagetitle={isEmaillOpen.title}
          toEmail={isEmaillOpen.toEmail}
          toName={isEmaillOpen.toName}
          ORDERID={isEmaillOpen.ORDERID}
          show={isEmaillOpen.show}
          skuData={isEmaillOpen.skuData}
          row={isEmaillOpen.row}
          defaultSubject={isEmaillOpen.defaultSubject}
          Quote_No={isEmaillOpen.Quote_No}
          setShow={setIsEmaillOpen}
          setIsSuccsessModalOpen={setIsSuccsessModalOpen}
        />
      )}
      {isExcelOpen.show && (
        <ExcelDialogOrder
          show={isExcelOpen.show}
          setShow={setIsExcelOpen}
          onDownload={(fields) => {
            handleGenerateExcel(fields);
            setIsExcelOpen({ show: false });
          }}
        />
      )}
      <SuccsessMsgModal
        show={isSuccsessModalOpen.show}
        onHide={() =>
          setIsSuccsessModalOpen({ ...isSuccsessModalOpen, show: false })
        }
        title={isSuccsessModalOpen?.title}
        btntext={isSuccsessModalOpen?.btntext}
        message={isSuccsessModalOpen?.message}
      />

      <div className="order_list_view">
        {Object.keys(data).length === 0 ? (
          <div className="text-center p-4">Loading...</div>
        ) : (
          <Accordion
            alwaysOpen
            activeKey={openAccordions}
            onSelect={handleAccordionSelect}
          >
            {Object.entries(data).map(([statusKey, statusObj], idx) => {
              const stages = statusObj?.stage || [];
              const activeStageValue = activeTabs[statusKey] ?? stages[0]?.value;
              const activeStage =
                stages.find((s) => s.value === activeStageValue) || stages[0];
              const totalCount = stages.reduce((sum, s) => sum + (s.total || 0), 0);
              const color = STATUS_COLORS[statusKey] || "#8A97AB";
              const isOpen = openAccordions.includes(String(idx));
              return (
                <Accordion.Item eventKey={String(idx)} key={statusKey}>
                  <Accordion.Header>
                    <div className="d-flex justify-content-between align-items-center w-100">
                      <span className="order_status_box">
                        {statusObj.display_name}{" "}
                        <b style={badgeStyle(color)}>{totalCount}</b>
                      </span>
                      {isOpen && stages.length > 1 && (
                        <div
                          className="table_tabs_group d-flex gap-2 me-3"
                          onClick={(e) => e.stopPropagation()}
                        >
                          {stages.map((s) => (
                            <span
                              key={s.value}
                              role="button"
                              tabIndex={0}
                              className={`btn btn-sm ${activeStageValue === s.value
                                  ? "btn-warning text-white"
                                  : "btn-outline-secondary"
                                }`}
                              onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                handleTabSelect(statusKey, s.value);
                              }}
                            >
                              {s.display_name} ({s.total || 0})
                            </span>
                          ))}
                        </div>
                      )}
                    </div>
                  </Accordion.Header>
                  <Accordion.Body>
                    {activeStage && renderStageTable(statusKey, activeStage)}
                  </Accordion.Body>
                </Accordion.Item>
              );
            })}
          </Accordion>
        )}
      </div>
    </>
  );
};

export default TableListingNew;